import React, { useState } from 'react';
import get from 'lodash/get';
import { ACTIVE_PLAN_ID, SCENARIO_ID_PROP_KEY } from '../../constants/app.constants';
import ScenarioCompareDrawer from '../../containers/ScenarioCompareDrawer';
import ComparisonDrawerTitle from './ScenarioComparisonDrawerTitle';
import BottomDrawer from '../BottomDrawer';

const ScenarioComparisonWrapper = ({
  selectedScenarios,
  title,
  onScenarioClick,
  handleDrawerCancel,
  visible,
  titleBarActions,
}) => {
  const activePlanSelected = get(selectedScenarios[0], SCENARIO_ID_PROP_KEY) === ACTIVE_PLAN_ID;
  const dateTargetScenario = activePlanSelected ? selectedScenarios[1] : selectedScenarios[0];
  const { fromDate, toDate } = dateTargetScenario || {};

  const [showKpiReport, setShowKpiReport] = useState(false);

  return (
    <BottomDrawer
      title={(
        <ComparisonDrawerTitle
          titleText={title}
          Actions={titleBarActions}
          selectedScenarios={selectedScenarios}
          fromDate={fromDate}
          toDate={toDate}
          showKpiReport={showKpiReport}
          setShowKpiReport={() => setShowKpiReport(!showKpiReport)}
        />
      )}
      onClose={handleDrawerCancel}
      visible={visible}
      drawerComponent={(
        <ScenarioCompareDrawer
          selectedScenarios={selectedScenarios}
          onClickToViewScenario={onScenarioClick}
          startDate={fromDate}
          endDate={toDate}
          showKpiReport={showKpiReport}
        />
      )}
    />
  );
};

export default ScenarioComparisonWrapper;
